// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__HmfOH","header":"styles_header__uUfga","logo":"styles_logo__jD12-","body":"styles_body__yBBfG","button":"styles_button__hq-h+"};